<template>
  <div>
    <NavBar />

    <div class="container">
      <v-btn
        class="v-primary mb-1"
        @click="
          errors = [];
          $bvModal.show('create-care');
        "
      >
        <span class="fa fa-plus"></span> Novo
      </v-btn>

      <b-overlay :show="loading" opacity="0.99">
        <v-card>
          <v-card-title>
            Cuidados
            <v-spacer />

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>

          <v-data-table
            dense
            :headers="headers"
            :items="prescription_care_itens"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [100, 200, 300],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.active`]="{ item }">
              {{ item.active == 1 ? "Ativo" : "Inativo" }}
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>

      <ErrorsMessages :errors="errors" />

      <CreateModal @create="getCares" />

      <UpdateModal
        v-if="prescription_care_item"
        :prescription_care_item="prescription_care_item"
        @update="getCares"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../templates/components/ErrorsMessages";

import NavBar from "../templates/NavBar";

import api from "../services/api";

import CreateModal from "../templates/PrescriptionCare/CreateModal";

import UpdateModal from "../templates/PrescriptionCare/UpdateModal";

export default {
  name: "PrescriptionCare",

  components: {
    NavBar,
    ErrorsMessages,
    CreateModal,
    UpdateModal,
  },

  data() {
    return {
      loading: false,

      errors: [],

      prescription_care_itens: [],

      prescription_care_item: [],

      name: "",

      search: "",

      headers: [
        { text: "Nome", sortable: false, value: "name" },
        { text: "Status", sortable: false, value: "active" },
      ],
    };
  },

  async created() {
    await this.getCares();

    this.loading = false;
  },

  methods: {
    async getCares() {
      try {
        this.loading = true;

        const response = await api.get("/admin/prescription-care-item/all");

        const { prescription_care_itens } = response.data;

        this.prescription_care_itens = prescription_care_itens;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    handleClickRowTable(item) {
      this.prescription_care_item = item;

      this.$bvModal.show("update-care");
    },
  },
};
</script>